import { render, staticRenderFns } from "./ButtonLoading.vue?vue&type=template&id=01234d50&"
import script from "./ButtonLoading.vue?vue&type=script&lang=js&"
export * from "./ButtonLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports